module.exports = __webpack_public_path__ + "static/img/RLB8_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RLB8_1.png
// module id = rEGG
// module chunks = 0